import { Box, Typography } from "@mui/material";

const TooltipContentContainer = ({ 
  children, 
  backgroundColor, 
  backgroundGradient,
  icon,
  iconBackground,
  iconBorder,
  title,
  titleColor = 'white',
}) => (
  <Box
    sx={{
      backgroundColor: backgroundColor,
      color: '#fff',
      padding: 2,
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: `''`,
        position: 'absolute',
        width: '100%',
        background: backgroundGradient,
        borderRadius: '50%',
        top: '-160px',
        right: '-130px'
      }
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      <Box
        sx={{
          background: iconBackground,
          border: iconBorder,
          display: 'flex',
          width: 28,
          height: 28,
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '6px',
          mr: 1
        }}
      >
        { icon }
      </Box>
      <Typography variant="subtitle2" color={titleColor} sx={{
        fontWeight: "bold"
      }}>
        { title }
      </Typography>
    </Box>
    { children }
  </Box>
)

export default TooltipContentContainer;